var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 412,
    viewBox: "0 0 412 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4605 80.2442C58.5578 86.9096 47.4785 104.762 45.3362 126.799C44.1814 138.675 46.2719 150.155 46.7796 161.987C47.5438 179.788 43.9396 194.197 34.0015 209.182C30.9233 213.823 28.8957 218.34 27.7606 222.944C24.6068 227.985 22.0993 233.457 20.7603 239.767C19.0495 247.826 20.0415 256.826 25.481 263.291C26.9434 265.029 30.3815 268.408 33.4405 269.614C28.13 293.059 27.7563 317.541 33.4816 340.653C36.938 354.604 40.707 368.492 44.5851 382.332C45.627 386.049 48.2177 391.994 48.672 385.278C49.0885 379.135 44.9851 370.536 43.4647 364.548C36.0595 335.377 29.3781 308.842 35.4425 278.735C36.0788 275.58 36.7965 272.43 37.5751 269.292C37.6467 269.226 37.7105 269.152 37.7754 269.079C37.8378 269.108 37.8961 269.142 37.9583 269.171C38.0128 268.991 38.0935 268.775 38.1898 268.531C38.5004 268.028 38.7361 267.428 38.9412 266.77C39.6873 265.047 40.5177 263.034 40.3142 262.077C40.3126 262.069 40.306 262.059 40.3044 262.051C45.1067 248.185 51.1453 234.753 57.4175 221.506C57.3699 221.603 64.0754 206.475 64.1784 214.004C64.2281 217.632 58.6433 225.789 56.609 230.09C52.119 239.652 47.0131 251.638 43.0799 263.009C42.3586 263.665 41.7039 266.251 41.2414 268.171C40.9688 269.152 40.729 270.134 40.4714 271C63.7876 273.407 77.5198 255.225 85.3542 235.865C85.3638 235.842 85.3716 235.819 85.3804 235.796C87.868 230.375 90.4483 224.969 94.1315 220.307C100.276 212.528 108.062 209.684 116.232 204.725C138.514 191.202 141.898 157.733 140.062 133.853C137.991 106.913 111.236 70.7825 80.4605 80.2442",
    fill: "#0F7B6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0277 275.085C101.095 273.753 121.271 288.329 129.986 303.497C137.012 315.726 135.828 331.785 131.489 344.778C128.583 353.476 122.241 365.878 111.665 365.999C98.433 366.15 97.795 349.796 97.5391 340.236C97.199 327.525 95.5929 316.453 85.5774 307.789C84.3408 306.72 83.0433 305.719 81.7459 304.718C80.5942 303.829 79.4427 302.941 78.3339 302.005C78.1567 301.855 77.9786 301.706 77.8 301.556C74.2585 298.579 70.539 295.453 70.0862 290.546C69.4296 283.436 73.4432 282.156 79.5713 283.477C79.769 283.52 80.3061 283.723 81.0366 284C84.166 285.186 90.8442 287.718 89.5809 284.692C89.1053 283.552 87.3679 282.648 85.175 281.971C79.5006 281.354 72.7336 280.638 70.7874 281.066C49.7918 285.672 41.6173 314.755 39.4464 333.233C39.212 335.228 39.0225 337.23 38.8572 339.234H35C35.2677 334.394 35.6211 329.562 36.4303 324.776C39.5247 306.473 49.2 279.591 70.4204 276.62C71.2032 276.51 74.083 276.491 77.5713 276.696C79.2245 275.772 81.0764 275.213 83.0277 275.085Z",
    fill: "#0E584E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 206,
    r: 206,
    fill: "#03CAA5"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.001 61.832C154.021 61.832 111.834 104.019 111.834 155.999C111.834 207.979 154.021 250.165 206.001 250.165C257.981 250.165 300.167 207.979 300.167 155.999C300.167 104.019 257.981 61.832 206.001 61.832ZM206.001 203.082C200.821 203.082 196.584 198.845 196.584 193.665V155.999C196.584 150.82 200.821 146.582 206.001 146.582C211.18 146.582 215.417 150.82 215.417 155.999V193.665C215.417 198.845 211.18 203.082 206.001 203.082ZM196.584 127.749H215.417V108.915H196.584V127.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.08 198.001C310.562 200.421 304.473 201.084 301.882 199.937C295.384 197.062 299.182 172.826 306.196 164.223C313.21 155.62 341.059 156.149 338.968 175.231C338.242 181.855 334.335 187.203 329.27 191.244L330.563 226.453L308.74 222.687L317.08 198.001Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.35248,
    ry: 1.97157,
    transform: "matrix(-0.983924 -0.178107 -0.188936 0.982082 304.301 179.262)",
    fill: "#222432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.388 176.778C307.036 176.955 308.913 179.734 308.74 179.864C308.566 179.995 306.706 178.274 305.253 177.961C304.107 177.713 303.151 178.088 303.047 177.768C302.976 177.549 304.142 176.644 305.388 176.778Z",
    fill: "#2E2232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.62 172.36C308.466 172.726 310.416 175.532 310.238 175.669C310.059 175.807 308.029 173.928 306.409 173.457C305.13 173.085 304.017 173.552 303.935 173.009C303.761 171.858 305.224 172.084 306.62 172.36Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.173 195.775C335.076 184.446 344.355 177.748 344.13 172.267C343.906 166.787 338.981 164.61 338.981 164.61C338.981 164.61 338.229 153.692 323.395 152.743C308.56 151.794 298.608 156.113 300.081 169.65C303.606 170.259 308.088 169.758 313.584 172.889C316.2 174.379 316.445 179.824 316.445 179.824L319.104 180.283C319.104 180.283 324.115 174.736 327.575 177.032C331.036 179.329 327.818 185.33 327.818 185.33L327.344 195.287L330.173 195.775Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.859 301.852L294.451 415.653L263.325 499.531H245.576L288.363 301.852L338.859 301.852Z",
    fill: "#727387"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.834 301.852C350.317 340.899 349.968 393.47 351.093 395.904C352.217 398.339 421.059 451.37 421.059 451.37L411.91 466.435C411.91 466.435 330.18 415.391 326.001 408.59C321.823 401.789 300.83 339.208 289.908 301.852H349.834Z",
    fill: "#9293A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.936 253.746L248.969 270.802L237.113 283.088L213.849 262.395C201.583 259.1 195.975 256.695 197.024 255.18C197.91 253.903 199.334 253.949 200.646 253.992C201.669 254.026 202.623 254.057 203.2 253.459C204.52 252.091 202.013 247.3 199.434 242.851C196.855 238.402 199.619 238.794 201.199 239.435C206.368 242.836 211.614 247.606 216.936 253.746ZM364.194 288.339L383.378 286.344C393.168 320.084 399.149 338.626 401.32 341.97C402.913 344.423 413.492 351.3 420.73 355.11C423.635 356.639 422.759 359.056 421.8 359.771C415.752 364.278 410.716 362.08 405.234 359.688C403.647 358.995 402.022 358.286 400.325 357.719C395.932 356.251 394.36 358.37 392.874 360.373C391.558 362.146 390.31 363.828 387.233 362.848C387.43 362.263 387.667 361.609 387.923 360.903C389.577 356.34 392.016 349.61 389.702 345.378C388.515 343.206 380.012 324.193 364.194 288.339Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.56 211.988L311.726 209.98C292.905 224.761 282.246 263.258 270.224 267.437C258.857 271.388 243.816 265.316 226.007 257.333L219.255 269.036C234.362 287.992 268.612 305.862 283.82 298.662C308.135 287.151 317.889 239.378 319.56 211.988Z",
    fill: "#011D69"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.349 311.799C345.349 311.799 297.504 307.668 274.961 305.721C271.745 305.443 272.764 300.998 273.437 298.768C281.207 273.037 304.745 246.61 308.167 209.323L328.753 207.992C343.146 235.6 345.998 268.306 345.349 311.799Z",
    fill: "#ECD189"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.402 207.788L330.067 208.105C373.112 239.215 396.767 283.721 401.032 341.624L386.021 343.148C377.26 331.278 366.856 312.192 354.809 285.889C357.825 301.368 359.618 317.131 359.276 331.86L295.917 326.389C286.406 295.309 322.029 207.412 322.029 207.412L326.402 207.79L326.402 207.788Z",
    fill: "#002FAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7 192.616C300.807 192.864 303.212 193.066 303.975 191.887",
    stroke: "#222432",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.99 266.037L157.074 272.016C157.86 272.29 158.68 272.256 159.431 271.982L169.442 268.087C173.918 266.345 178.735 269.625 178.735 274.442L178.735 314.93C178.735 317.868 176.856 320.499 174.089 321.421L160.456 326C159.021 326.478 157.45 326.478 156.015 325.966L138.931 319.986C138.18 319.713 137.325 319.713 136.574 320.021L126.563 323.916C122.087 325.658 117.27 322.378 117.27 317.561L117.27 277.073C117.27 274.135 119.149 271.538 121.916 270.581L135.549 266.003C136.984 265.525 138.555 265.525 139.99 266.037ZM137.77 312.334L158.27 319.543L158.27 279.671L137.77 272.461L137.77 312.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.632 334.5C207.825 334.5 208.972 334.972 209.827 335.827L220.672 346.695C221.527 347.527 222 348.675 222 349.867L222 375C222 377.475 219.975 379.5 217.5 379.5L190.477 379.5C188.002 379.5 186 377.475 186 375L186 339C186 336.525 188.025 334.5 190.5 334.5L206.632 334.5ZM197.25 370.5L210.75 370.5C211.988 370.5 213 369.487 213 368.25C213 367.012 211.988 366 210.75 366L197.25 366C196.013 366 195 367.012 195 368.25C195 369.487 196.013 370.5 197.25 370.5ZM210.75 361.5L197.25 361.5C196.013 361.5 195 360.488 195 359.25C195 358.013 196.013 357 197.25 357L210.75 357C211.988 357 213 358.013 213 359.25C213 360.488 211.988 361.5 210.75 361.5ZM206.25 337.875L206.25 348C206.25 349.238 207.263 350.25 208.5 350.25L218.625 350.25L206.25 337.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: -6,
    y: -6,
    width: 432,
    height: 432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 412,
    rx: 206,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.c119a4dc72d7a10d2d50fe94af96a044.svg";
export { ForwardRef as ReactComponent };